function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 24,
  height: 24
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.99722,10.56372a2.72,2.72,0,1,1,2.72022-2.72021A2.7232,2.7232,0,0,1,11.99722,10.56372Zm0-4.43994a1.72,1.72,0,1,0,1.72022,1.71973A1.7218,1.7218,0,0,0,11.99722,6.12378Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.76,16.38c1.63-2.26,3.49-5.61,3.49-9.13a6.255,6.255,0,1,0-12.51,0c0,3.52,1.86,6.88,3.49,9.14-3.24.37-6.25,1.46009-6.25,3.23,0,2.21008,4.64,3.39,9.02,3.39,4.37,0,9.02-1.17993,9.02-3.39C21.02,17.74,17.82,16.73,14.76,16.38ZM6.74,7.25a5.255,5.255,0,1,1,10.51,0c0,4.87-4.03,9.61-5.25,10.93994C10.77,16.86,6.74,12.12,6.74,7.25ZM12,22.01c-4.97,0-8.02-1.39-8.02-2.39,0-.88,2.26-1.99,5.94-2.30994a21.73233,21.73233,0,0,0,1.72,1.96l.36.34.35-.34a23.72311,23.72311,0,0,0,1.72-1.96C17.76,17.63,20.02,18.74,20.02,19.62,20.02,20.62,16.96,22.01,12,22.01Z"
});

var SvgZonesOutline = function SvgZonesOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZonesOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zones_outline.183e42a2.svg";
export { ForwardRef as ReactComponent };